import { useState } from 'react';

const API_URL =
  import.meta.env.VITE_WORKER_API_URL ||
  'https://clarity-platform-api.ryan-dc4.workers.dev';

export function Landing() {
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    const data = new FormData(e.currentTarget);
    const emailVal = String(data.get('email') ?? '');
    try {
      const res = await fetch(`${API_URL}/auth/request-link`, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ email: emailVal }),
      });
      if (!res.ok) {
        const body = await res.json().catch(() => ({}));
        throw new Error((body as { error?: string }).error ?? `${res.status}`);
      }
      setSent(true);
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : 'unknown error');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <main className="min-h-screen flex items-center justify-center px-6">
      <div className="max-w-md w-full">
        <p className="text-sm uppercase tracking-widest text-sky-400 text-center">
          Clarity Admin
        </p>
        {sent ? (
          <div className="mt-6 rounded-lg border border-emerald-700/40 bg-emerald-900/10 p-6 text-center">
            <h1 className="text-2xl font-semibold">Check your email.</h1>
            <p className="mt-3 text-slate-400">
              We sent a login link. It expires in 15 minutes.
            </p>
          </div>
        ) : (
          <form className="mt-6 space-y-3" onSubmit={handleSubmit}>
            <h1 className="text-2xl font-semibold text-center">Admin login</h1>
            <input
              type="email"
              required
              name="email"
              placeholder="you@example.com"
              className="w-full rounded-md border border-slate-700 bg-slate-900 px-4 py-3 text-slate-100 placeholder-slate-500 focus:border-sky-400 focus:outline-none"
            />
            <button
              type="submit"
              disabled={submitting}
              className="w-full rounded-md bg-sky-500 hover:bg-sky-400 disabled:opacity-50 px-4 py-3 font-semibold text-slate-950"
            >
              {submitting ? 'Sending…' : 'Email me a login link'}
            </button>
            {error && (
              <p className="text-sm text-red-400 text-center">{error}</p>
            )}
          </form>
        )}
      </div>
    </main>
  );
}
